import { Globe, Lock } from 'lucide-react';

/**
 * Bottom status bar of the Editor: word/char count, save state, encryption, publish indicator.
 */
export default function EditorStatusBar({
  isJournalEntry, selectedNote, isEncryptionEnabled,
  wordCount, charCount, saving, saved, setShowPublish,
}) {
  return (
    <div className="flex items-center justify-between px-3 sm:px-4 py-2 border-t border-border/30 text-xs text-muted-foreground min-h-[36px]" data-testid="editor-status-bar">
      <div className="flex items-center gap-3">
        {!isJournalEntry && selectedNote?.is_published && (
          <button
            onClick={() => setShowPublish(true)}
            className="flex items-center gap-1 text-green-400 hover:text-green-300 transition-colors"
            data-testid="editor-published-indicator"
          >
            <Globe className="w-3 h-3" />
            <span className="hidden sm:inline">Published — changes are live</span>
          </button>
        )}
        <span>{wordCount} words</span>
        <span className="hidden sm:inline">{charCount} chars</span>
      </div>
      <div className="flex items-center gap-2">
        {isEncryptionEnabled && selectedNote?.is_encrypted && (
          <span className="flex items-center gap-1 text-accent-amber" data-testid="editor-encryption-indicator">
            <Lock className="w-3 h-3" /> <span className="hidden sm:inline">Encrypted</span>
          </span>
        )}
        <span data-testid="editor-save-status">
          {saving ? 'Saving...' : saved ? 'Saved' : 'Unsaved'}
        </span>
      </div>
    </div>
  );
}
